import gql from "graphql-tag";

export const updateAuthenticationState = gql`
  mutation updateAuthenticationState(
    $authenticated: Boolean
    $selectedProject: String
    $needsToOnboard: Boolean
    $uid: String
    $darkMode: Boolean
  ) {
    updateAuthenticationState(
      authenticated: $authenticated
      selectedProject: $selectedProject
      needsToOnboard: $needsToOnboard
      uid: $uid
      darkMode: $darkMode
    ) @client {
      authenticated
      selectedProject
      needsToOnboard
      uid
      darkMode
    }
  }
`;

export const updateAuthenticationStateOptions = {
  name: "updateAuthenticationState",
};
